var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "153",
        height: "133",
        viewBox: "0 0 153 133",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M135.32 110.96C146.133 99.2097 152.3 83.9251 152.67 67.9605C153.366 57.7848 151.259 47.6131 146.58 38.5505C140.887 26.3076 131.579 16.1031 119.91 9.31046C111.394 3.92017 101.651 0.775655 91.59 0.170459C81.5131 -0.576601 71.4057 1.13942 62.14 5.17046C53.5818 8.62751 45.8424 13.8383 39.4199 20.4675C32.9975 27.0966 28.0343 34.9971 24.85 43.6605C20.59 39.3805 13.57 33.7405 4.44 32.4505C9.66 42.5105 15.73 54.9205 14.62 70.9405C13.74 83.7605 7.86 93.7805 2.2 101.47C1.3 102.7 0.58 103.79 0 104.67C9 103.76 16.39 100.92 21.57 96.2505C23.104 94.8308 24.5595 93.3285 25.93 91.7505C32.5712 107.628 45.1562 120.281 60.9982 127.007C76.8402 133.733 94.684 134 110.72 127.75C119.158 124.713 126.794 119.795 133.05 113.37C133.82 112.6 134.58 111.78 135.32 110.96Z",
          fill: "#3399FF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M114.39 23.0204C126.39 21.8004 135.73 30.4704 135.73 42.3904C135.771 44.9538 135.301 47.4997 134.347 49.8793C133.393 52.2588 131.974 54.4243 130.173 56.2492C128.373 58.0741 126.226 59.5217 123.86 60.5075C121.493 61.4933 118.954 61.9974 116.39 61.9904C104.6 62.1904 96.7 53.2404 96.53 42.6304C96.6154 38.6893 97.7289 34.8389 99.76 31.4604C102.7 27.0604 107.18 23.7504 114.39 23.0204Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M116.04 62.6204C104.77 62.6204 96.1201 54.0304 95.9301 42.6204C96.0243 38.5538 97.1717 34.5811 99.2601 31.0904C102.71 25.9104 107.65 23.0904 114.36 22.3804C115.124 22.3008 115.892 22.2608 116.66 22.2604C127.91 22.2704 136.39 30.9204 136.39 42.3904C136.438 45.0404 135.955 47.6733 134.97 50.1338C133.985 52.5943 132.517 54.8327 130.653 56.7171C128.789 58.6014 126.567 60.0937 124.117 61.1058C121.668 62.118 119.04 62.6296 116.39 62.6104L116.04 62.6204ZM116.66 23.5204C115.94 23.5204 115.21 23.5204 114.49 23.6304C108.17 24.2804 103.49 26.9504 100.29 31.8004C98.329 35.0754 97.2538 38.8042 97.1701 42.6204C97.1498 45.099 97.6249 47.5566 98.5675 49.849C99.51 52.1414 100.901 54.2224 102.659 55.9699C104.416 57.7174 106.506 59.0962 108.803 60.0253C111.101 60.9544 113.562 61.4152 116.04 61.3804H116.39C118.877 61.3928 121.341 60.908 123.638 59.9544C125.935 59.0008 128.018 57.5977 129.765 55.8276C131.512 54.0575 132.887 51.956 133.81 49.6467C134.733 47.3375 135.185 44.867 135.14 42.3804C135.15 31.6304 127.2 23.5204 116.66 23.5204Z",
          fill: "#666666",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M129.77 46.4105C129.772 47.7815 129.367 49.1224 128.607 50.2633C127.847 51.4042 126.765 52.294 125.499 52.8201C124.233 53.3461 122.839 53.4848 121.494 53.2185C120.149 52.9523 118.913 52.293 117.943 51.3243C116.973 50.3555 116.312 49.1207 116.044 47.7761C115.776 46.4316 115.912 45.0377 116.436 43.7708C116.961 42.5039 117.849 41.421 118.989 40.6591C120.129 39.8972 121.469 39.4905 122.84 39.4905C124.676 39.4905 126.437 40.2192 127.737 41.5167C129.036 42.8142 129.767 44.5743 129.77 46.4105Z",
          fill: "black",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }